import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { ITvodOtpGenerateRequest } from '../../../entity/interface/iEntitlements';
export interface ITvodOtpGenerateUseCase {
    execute(payload: ITvodOtpGenerateRequest, username: string, token: string, identityToken: string): Promise<any>;
}

export class TvodOtpGenerateUseCase implements ITvodOtpGenerateUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get tvodOtpGenerateRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: ITvodOtpGenerateRequest,
        username: string,
        token: string,
        identityToken: string
    ): Promise<any> {
        return this.tvodOtpGenerateRepository.tvodOtpGenerate(payload, username, token, identityToken);
    }
}
